<div class="dialog-title" mat-dialog-title>
  {{'app.legal-notice-dialog.title' | translate}}
  <button mat-icon-button [mat-dialog-close]="false">
    <fa-icon [icon]="faTimes" size="lg"></fa-icon>
  </button>
</div>
<div mat-dialog-content>
  <div class="legal-notice-content">
    <div [innerHTML]="legalNoticeContent"></div>
  </div>
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-raised-button (click)="onOkClick()" type="button" color="primary">{{'common.ok' | translate}}</button>
</div>